<div class="heading py-5">
  <h1 class="bold font-curve-large">Datepicker</h1>
  <app-dependency-link></app-dependency-link>
</div>

<div class="alert alert-warning mb-bigger-big">
  <p>
    The
    <code>.pi-calendar</code>
    class previously used to display the calendar icon in the datepicker button has been deprecated
    in favor of the
    <code>.pi-3203</code>
    class which shows the same icon.
  </p>
</div>

<section>
  <p id="languageSelectorTitle" class="light font-curve-regular">Choose a language:</p>

  <fieldset aria-labelledby="languageSelectorTitle" class="btn-group mb-3">
    <input
      [(ngModel)]="language"
      autocomplete="off"
      class="btn-check"
      id="btn-check-en"
      type="radio"
      value="en"
    />
    <label class="btn btn-secondary" for="btn-check-en">English</label>

    <input
      [(ngModel)]="language"
      autocomplete="off"
      class="btn-check"
      id="btn-check-de"
      type="radio"
      value="de"
    />
    <label class="btn btn-secondary" for="btn-check-de">German</label>

    <input
      [(ngModel)]="language"
      autocomplete="off"
      class="btn-check"
      id="btn-check-fr"
      type="radio"
      value="fr"
    />
    <label class="btn btn-secondary" for="btn-check-fr">Francais</label>

    <input
      [(ngModel)]="language"
      autocomplete="off"
      class="btn-check"
      id="btn-check-it"
      type="radio"
      value="it"
    />
    <label class="btn btn-secondary" for="btn-check-it">Italiano</label>
  </fieldset>

  <div class="alert alert-info" role="alert">
    <p>
      If you use internationalization, check out the custom
      <a href="#internationalization">datepicker internationalization service</a>
      below
    </p>
  </div>
</section>

<section>
  <h3 class="bold">Simple datepicker</h3>

  <div class="row row-cols-md-2 row-cols-lg-3 mb-3 align-items-end">
    <div class="col">
      <div class="mb-4">
        <app-datepicker-simple
          *ngIf="dpSimpleSize !== 'lg'"
          [inputSize]="dpSimpleSize"
          [language]="language"
          [navigation]="dpNavigation.value"
        ></app-datepicker-simple>
        <app-datepicker-simple-lg
          *ngIf="dpSimpleSize === 'lg'"
          [inputSize]="dpSimpleSize"
          [language]="language"
          [navigation]="dpNavigation.value"
        ></app-datepicker-simple-lg>
      </div>

      <label for="size" class="form-label">
        Datepicker Size:
        <span class="bold">{{ dpSimpleSize }}</span>
      </label>
      <input
        type="range"
        class="form-range"
        min="0"
        max="3"
        id="size"
        [formControl]="sizeRangeSimple"
        name="sizerangesimple"
      />
    </div>
    <div class="col">
      <label for="navigation" class="form-label">Choose datepicker navigation style</label>
      <select id="navigation" class="form-select form-select-rg" [formControl]="dpNavigation">
        <option value="arrows">Arrows</option>
        <option value="select">Select</option>
      </select>
    </div>
  </div>

  <h4 class="h5 bold mt-4">datepicker.component.html</h4>
  <code
    *ngIf="dpSimpleSize !== 'lg'"
    [highlight]="dpSimpleHtml"
    [languages]="['html']"
    class="block"
  ></code>
  <code
    *ngIf="dpSimpleSize === 'lg'"
    [highlight]="dpSimpleHtmlLg"
    [languages]="['html']"
    class="block"
  ></code>
  <h4 class="h5 bold mt-4">datepicker-simple.component.ts</h4>
  <code class="block" [highlight]="dpSimpleTs" [languages]="['typescript', 'javascript']"></code>
</section>

<section>
  <h3 class="bold mt-5">Datepicker with validation</h3>
  <div class="row row-cols-md-2 row-cols-lg-3">
    <div class="col">
      <div class="mb-4">
        <app-datepicker-validation
          *ngIf="dpValidationSize !== 'lg'"
          [inputSize]="dpValidationSize"
          [language]="language"
        ></app-datepicker-validation>
        <app-datepicker-validation-lg
          *ngIf="dpValidationSize === 'lg'"
          [inputSize]="dpValidationSize"
          [language]="language"
        ></app-datepicker-validation-lg>
      </div>

      <label for="size-validation" class="form-label">
        Datepicker Size:
        <span class="bold">{{ dpValidationSize }}</span>
      </label>
      <input
        type="range"
        class="form-range"
        min="0"
        max="3"
        id="size-validation"
        [formControl]="sizeRange"
        name="sizerange"
      />
    </div>
  </div>

  <h4 class="h5 bold mt-4">datepicker.component.html</h4>
  <code
    *ngIf="dpValidationSize !== 'lg'"
    [highlight]="dpValidationHtml"
    [languages]="['html']"
    class="block"
  ></code>
  <code
    *ngIf="dpValidationSize === 'lg'"
    [highlight]="dpValidationHtmlLg"
    [languages]="['html']"
    class="block"
  ></code>
  <h4 class="h5 bold mt-4">datepicker-simple.component.ts</h4>
  <code
    class="block"
    [highlight]="dpValidationTs"
    [languages]="['typescript', 'javascript']"
  ></code>
</section>

<app-ngb-localization>
  <p class="light font-curve-regular mt-4">
    The datepicker requires additional translations for months and days of the week. These can be
    configured using the service below:
  </p>

  <code
    class="block"
    [highlight]="localizationService"
    [languages]="['typescript', 'javascript']"
  ></code>
</app-ngb-localization>
